module.exports = __webpack_public_path__ + "img/ai.f1595bcd.svg";